import { useEffect, useRef, useState } from "react";

// Trefferliste unter einem Suchfeld (07.10.2026, Ralph): bisher schloss die Liste 200 ms nach
// dem Verlassen des Suchfelds ("onBlur"). Ein normaler Mausklick (Taste etwas laenger gedrueckt)
// kam dann zu spaet an - nichts passierte. Jetzt schliesst die Liste nur bei Klick/Tipp
// AUSSERHALB von Suchfeld + Liste, mit Esc oder wenn der Fokus per Tab woanders hingeht.
// Tastatur: Pfeil runter springt in die Treffer, Pfeil hoch/runter blaettert, Enter oeffnet.
export const useTrefferListe = () => {
  const [offen, setOffen] = useState(false);
  const boxRef = useRef(null);
  const listRef = useRef(null);

  useEffect(() => {
    if (!offen) return undefined;
    const aussen = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOffen(false); };
    document.addEventListener("pointerdown", aussen);
    return () => document.removeEventListener("pointerdown", aussen);
  }, [offen]);

  const knoepfe = () => Array.from(listRef.current?.querySelectorAll("button:not([disabled])") || []);
  const zumSuchfeld = () => boxRef.current?.querySelector("input")?.focus();

  return {
    offen,
    setOffen,
    boxProps: {
      ref: boxRef,
      // Fokus verlaesst den Bereich (z. B. mit Tab) -> Liste zu; Klick auf einen Treffer bleibt innerhalb
      onBlur: (e) => { if (e.relatedTarget && !boxRef.current?.contains(e.relatedTarget)) setOffen(false); },
    },
    inputProps: {
      onFocus: () => setOffen(true),
      onInput: () => setOffen(true),
      onKeyDown: (e) => {
        if (e.key === "ArrowDown") {
          const b = knoepfe();
          if (b.length) { e.preventDefault(); setOffen(true); b[0].focus(); }
        } else if (e.key === "Escape") {
          setOffen(false);
        }
      },
    },
    listProps: {
      ref: listRef,
      "data-trefferliste": "",
      onKeyDown: (e) => {
        const b = knoepfe();
        const i = b.indexOf(document.activeElement);
        if (e.key === "ArrowDown") { e.preventDefault(); b[Math.min(i + 1, b.length - 1)]?.focus(); }
        else if (e.key === "ArrowUp") { e.preventDefault(); if (i <= 0) zumSuchfeld(); else b[i - 1].focus(); }
        else if (e.key === "Escape") { setOffen(false); zumSuchfeld(); }
      },
    },
  };
};
